<script>
import numeral from 'numeral'
import { ResultCounter } from '@/components/page/result-counter'
import { toThaiDatetime } from '@/utils/datetime'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'

const Tag = () => import('./Tag')

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },

    pagination: {
      type: Object,
      default: () => ({})
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    async fetch() {
      try {
        this.isLoading = true

        await new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, 2000)
        })

        this.isLoading = false
      } catch (err) {
        this.$notify.error(err.message)
      }
    },

    reset() {
      this.pagination.page = 1
    },

    getType(type) {
      switch (type) {
        case 'transfer':
          return 'โอนออก'

        case 'receive':
          return 'รับเข้า'
      }
    },

    toDetailPage(id, type) {
      this.$emit('view', id, type)
    },

    handleCurrentChange(value) {
      this.$emit('pageChange', value)
    }
  },

  render() {
    const DetailButton = ({ props }) => (
      <el-button
        size="medium"
        onClick={() => {
          this.toDetailPage(props.dataId, props.type)
        }}
      >
        See Detail <i class="el-icon-arrow-right"></i>
      </el-button>
    )

    return (
      <el-card
        {...{ directives: [{ name: 'loading', value: this.loading }] }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
      >
        <ResultCounter
          value={this.pagination.total}
          style={{ marginBottom: '1rem' }}
        >
          ผลลัพธ์
        </ResultCounter>
        <el-table
          data={this.items}
          headerCellClassName={elementUiStyles.tableCell}
          cellClassName={elementUiStyles.tableCell}
          rowStyle={{ height: '4rem' }}
        >
          <el-table-column
            className={this.$style.verticalCell}
            width="23"
            scopedSlots={{
              default: ({ row }) => <Tag type={row.status} />
            }}
          />
          <el-table-column label="ID" prop="id" minWidth="150" />
          <el-table-column
            label="วันที่โอน"
            minWidth="150"
            scopedSlots={{ default: ({ row }) => toThaiDatetime(row.date) }}
          />
          <el-table-column
            label="ประเภท"
            minWidth="80"
            scopedSlots={{ default: ({ row }) => this.getType(row.type) }}
          />
          <el-table-column
            label="สาขาต้นทาง/ปลายทาง"
            prop="target"
            minWidth="140"
          />
          <el-table-column
            label="ช่องทางรับ/จ่าย"
            prop="method"
            minWidth="140"
          />
          <el-table-column
            label="จำนวนเงิน (บาท)"
            align="right"
            minWidth="110"
            scopedSlots={{
              default: ({ row }) => numeral(row.amount).format('0,0.00')
            }}
          />
          <el-table-column
            width="150"
            scopedSlots={{
              default: ({ row }) => (
                <DetailButton dataId={row.id} type={row.type} />
              )
            }}
          />
        </el-table>
        <div
          style={{
            display: 'flex',
            marginTop: '1rem',
            overflow: 'auto hidden'
          }}
        >
          <el-pagination
            background
            currentPage={this.pagination.page}
            total={this.pagination.total}
            pageSize={this.pagination.pageSize}
            layout="prev, pager, next, jumper"
            style={{ margin: 'auto' }}
            on={{
              'current-change': this.handleCurrentChange
            }}
          />
        </div>
      </el-card>
    )
  }
}
</script>

<style src="./style.module.scss" lang="scss" module></style>
